// @ts-nocheck
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export interface ProductListSearchFilterItemStyle {
    title?: TypographyPresentationProps;
    link?: LinkPresentationProps;
}

export const productListItems: ProductListSearchFilterItemStyle = {
    title: {
        forwardAs: "h2",
        variant: "h5",
        color: "text.main",
        css: css`
            margin: 0;
            ${({ theme }) => `
                font-size: ${theme.design.typography.size.base};
                font-weight: ${theme.design.typography.weight.medium};
            `}
        `,
    },
    link: {
        color: "secondary",
        typographyProps: {
            css: css`
                ${({ theme }) => `
                    font-size: ${theme.design.typography.size.smaller};
                    font-weight: ${theme.design.typography.weight.bold};
                `}
            `,
        },
        css: css`
            color: ${getColor("secondary")};
            padding: ${pxToRem(3)};

            &:hover {
                text-decoration: underline;
            }
        `,
    },
};
